<template>
    <div class="bidding">
        <div class="bidding_container">
            <div class="bidding_writie_con">  
                <div style="width: 700px; margin-left: 100px;margin-top: 30px;">
                    <!-- <StepProgress :steps="mySteps" :current-step="currentStep" icon-class="fa fa-check"></StepProgress> -->
                </div>
                <BiddingCategory   :category="category"></BiddingCategory>
                <BiddingContent    ></BiddingContent>
                <BiddingRange      :range="range" ></BiddingRange>     
                <BiddingComplete   :result="result" ></BiddingComplete>     
            </div>
            <input type="file" id="attached_file" style="margin-left: 50px; opacity:0; width: 1px; height: 1px" >  
        </div>
    </div>
</template>
<script>
import EventBus from "@/EventBus.js";
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
import BiddingCategory from "@/SPA/Components/Bidding/BiddingCategory.vue"
import BiddingContent from "@/SPA/Components/Bidding/BiddingContent.vue"
import BiddingRange from "@/SPA/Components/Bidding/BiddingRange.vue"
import BiddingComplete from "@/SPA/Components/Bidding/BiddingComplete.vue"
export default {
    components:{
        StepProgress, BiddingCategory, BiddingContent,BiddingRange,BiddingComplete
    },
    data(){
        return{
            mySteps:['카테고리,위치 선택', '프로젝트 내용 입력', '가격, 기간 선택'],
            currentStep:3,
            result :{
                category : {
                    popcon_category:"",
                    local : "",                
                },
                content : {
                    title:"",
                    content:"",
                    file:""
                },
                range : {
                    finance_range:"",
                    period_range:"",
                    end_at:""
                }    
            },
            category : {
                popcon_category:"",
                local : "",       
                service:"",         
            },
            range : {
                finance_range:"",
                period_range:"",
                end_at:""
            }    
        }
    },
    methods:{
        prevStep(){
            this.currentStep = this.currentStep -1
            if (this.currentStep == -1) this.currentStep=0
        },
        nextStep(){
            if(this.currentStep == 0){
                if( this.result.category.popcon_category == "" || this.result.category.local == "" ){
                    alert("비딩 카테고리 / 지역을 선택해주세요")
                    return false;
                }
             
            }

            this.currentStep = this.currentStep +1
        },
        get_bid_pre_data(){
            this.$http.get("app/get_bid_pre_data").then(res=>{
                this.category.popcon_category = res.data.popcon_category
                this.category.service = res.data.service                
                this.category.local =  res.data.local
                this.range.finance_range = res.data.finance
                this.range.period_range = res.data.period
            })
        },
        toggle_modal() {
            this.$emit("toggle_modal");
        },
        readImage(input) {
            if ( input.files && input.files[0] ) {
                var FR= new FileReader();
                FR.onload = function(e) {
                    $('#img').attr( "src", e.target.result );
                    $('#source').text( e.target.result );
                };       
                FR.readAsDataURL( input.files[0] );
            }
        }
    },
    mounted(){ 

        this.get_bid_pre_data()
        // 파일을 클릭해서 올린경우
        $(document).on("change","input[type=file]", ()=>{
           var file_name = $("input[type=file]")[0].files[0].name;
           $("#bid_attached_file").text( file_name )
           this.result.content.file = file_name
        });
        $(document).on("change keyup paste","#bid_title_input", ()=>{
           this.result.content.title = $("#bid_title_input").val()
        })

        $(document).on("change",".bidding_text_area", ()=>{
            this.result.content.content = $(".bidding_text_area").val()
        })


        EventBus.$on("select_popcon_category", data=>{
            this.result.category.popcon_category = data
        })
        EventBus.$on("select_local_category", data=>{
            this.result.category.local = data
        })
        EventBus.$on("select_finance_range", data=>{
            this.result.range.finance_range = data
        })
        EventBus.$on("select_period_range", data=>{
            this.result.range.period_range = data
        })
        EventBus.$on("select_end_date",data=>{
            this.result.range.end_at = data
        })
        EventBus.$on("bidding_prev", data=>{             
            this.prevStep()
        })
        EventBus.$on("bidding_next", data=>{
            if(this.currentStep == 1){
                console.log("데이터 받기")
                console.log(data)
                $("#baseFile").change(function(){
                    readImage( this );
                });
                $("#baseFile").trigger("change");
                this.result.content.title = data.title
                this.result.content.content = data.bid_content            
            }
            if(this.currentStep == 2){
                this.result.content.file = $("#attached_file")[0].files[0].name
            }
            if(this.currentStep == 3){
                var formData = new FormData()
                formData.append('popcon_category', this.result.category.popcon_category);
                formData.append('local', this.result.category.local);
                formData.append('title', this.result.content.title);
                formData.append('content', this.result.content.content);
                formData.append('finance_range', this.result.range.finance_range);
                formData.append('period_range', this.result.range.period_range);
                formData.append('end_at', this.result.range.end_at);
                formData.append('file',$("#attached_file")[0].files[0]);                
                this.$http.post("app/upload_bidding_data",formData,{ headers: {'Content-Type': 'multipart/form-data'}}).then(res=>{
                    alert("제출하였습니다. 해당 프로젝트는 심사를 거친후 공개되게 됩니다. 감사합니다.")
                    location.href="/"
                })
            }
            this.nextStep()           

        })
        
    },
   
    destroyed () {
       
    }
}
</script>
<style lang="scss" scoped>
.bidding{  
    width: 100%;
    .bidding_container{
        width: 900px;
        z-index: 1000;
        margin: 0px auto;      
        background-color:#fff;
        margin-bottom: 300px;
    }
    .bidding_x_btn{
        float:right;
        margin-top: -40px;
        margin-right: -40px;
        color:#fff;
        cursor: pointer;
    }
    .prev{
        display: inline-block;
        margin: 0 7px 0 0;
        padding: 0 5px;
        text-decoration: none;
        text-align: center;
        font-size: 13px;        
        color: #fff;
        outline-style: none;
        background-color: #f27824;
        border: 1px solid #f27824;
        line-height: 31px;       
        font-weight: bold;
        width: 71px;
        height: 31px;
        float: left;
        margin:30px;
        cursor: pointer;
    }
    .next{
        display: inline-block;
        margin: 0 7px 0 0;
        padding: 0 5px;
        text-decoration: none;
        text-align: center;
        font-size: 13px;        
        color: #fff;
        outline-style: none;
        background-color: #f27824;
        border: 1px solid #f27824;
        line-height: 31px;       
        font-weight: bold;
        width: 71px;
        height: 31px;
        float: right;
        margin: 30px;
        cursor: pointer;
    }
}
</style>


// WEBPACK FOOTER //
// src/SPA/Components/Bidding/Bidding.vue